import { createSlice } from '@reduxjs/toolkit';
import {
  fetchTableColumnData,
  fetchAggregatorData,
  fetchKnowledgeBaseData,
  syncKnowledgeBaseItems,
  exportWorkbenchFile,
  exportSchemaToWorkbenchFile
} from '../thunks/aggregatorThunks';

const initialState = {
  tableColumnData: null,
  defaultQuery: null,
  dataset: null,
  selectedKPI: 'total_clicks',
  listOfKPI: [],
  plotData: null,
  tableColumnDataLoading: false,
  aggregatorDataLoading: false,
  lineChartDataLoading: false,
  knowledgeBaseData: null,
  knowledgeBaseLoading: false,
  syncKnowledgeBaseLoading: false,
  syncKnowledgeBaseSuccess: null,
  error: null,
  sqlQuery: null,
  userInput: null,
  dataMapType: '',
  outputSchema: '',
  loadingExportSchemaToWorkbenchFileApi: false,
  loadingexportWorkbenchFileApi: false,
};

const aggregatorSlice = createSlice({
  name: 'aggregator',
  initialState,
  reducers: {
    setSelectedKPI(state, action) {
      state.selectedKPI = action.payload;
    },
    resetSyncKnowledgeBaseSuccess(state) {
      state.syncKnowledgeBaseSuccess = null;
    },
    setLineChartDataLoading(state, action) {
      state.lineChartDataLoading = action.payload;
    },
    setSqlQuery(state, action) { // Added reducer for sqlQuery
      state.sqlQuery = action.payload;
    },
    setUserInput(state, action) { // Added reducer for userInput
      state.userInput = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTableColumnData.pending, (state) => {
        state.tableColumnDataLoading = true;
        state.error = null;
      })
      .addCase(fetchTableColumnData.fulfilled, (state, action) => {
        state.tableColumnData = action.payload.table_info;
        state.defaultQuery = action.payload.default_query;
        state.tableColumnDataLoading = false;
      })
      .addCase(fetchTableColumnData.rejected, (state, action) => {
        state.tableColumnDataLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchAggregatorData.pending, (state) => {
        state.aggregatorDataLoading = true;
        state.error = null;
      })
      .addCase(fetchAggregatorData.fulfilled, (state, action) => {
        state.dataset = action.payload.dataset;
        state.listOfKPI = action.payload.KPI;
        state.aggregatorDataLoading = false;
      })
      .addCase(fetchAggregatorData.rejected, (state, action) => {
        state.aggregatorDataLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchKnowledgeBaseData.pending, (state) => {
        state.knowledgeBaseLoading = true;
        state.error = null;
      })
      .addCase(fetchKnowledgeBaseData.fulfilled, (state, action) => {
        state.knowledgeBaseData = action.payload;
        state.knowledgeBaseLoading = false;
      })
      .addCase(fetchKnowledgeBaseData.rejected, (state, action) => {
        state.knowledgeBaseLoading = false;
        state.error = action.payload;
      })
      .addCase(syncKnowledgeBaseItems.pending, (state) => {
        state.syncKnowledgeBaseLoading = true;
        state.error = null;
      })
      .addCase(syncKnowledgeBaseItems.fulfilled, (state, action) => {
        state.syncKnowledgeBaseSuccess = action.payload;
        state.syncKnowledgeBaseLoading = false;
      })
      .addCase(syncKnowledgeBaseItems.rejected, (state, action) => {
        state.syncKnowledgeBaseSuccess = false;
        state.syncKnowledgeBaseLoading = false;
        state.error = action.payload;
      })
      .addCase(exportWorkbenchFile.pending, (state) => {
        state.loadingexportWorkbenchFileApi = true;
      })
      .addCase(exportWorkbenchFile.fulfilled, (state, action) => {
        state.loadingexportWorkbenchFileApi = false;
        state.dataMapType = action.payload['dataMapType'];
      })
      .addCase(exportWorkbenchFile.rejected, (state, action) => {
        state.loadingexportWorkbenchFileApi = false
      })
      .addCase(exportSchemaToWorkbenchFile.pending, (state) => {
        state.loadingExportSchemaToWorkbenchFileApi = true;
      })
      .addCase(exportSchemaToWorkbenchFile.fulfilled, (state, action) => {
        state.loadingExportSchemaToWorkbenchFileApi = false;
        state.outputSchema = action.payload['outputSchema'];
      })
      .addCase(exportSchemaToWorkbenchFile.rejected, (state, action) => {
        state.loadingExportSchemaToWorkbenchFileApi = false;
      })
  },
});

export const { setSelectedKPI, resetSyncKnowledgeBaseSuccess, setLineChartDataLoading, setSqlQuery, setUserInput } = aggregatorSlice.actions;
export default aggregatorSlice.reducer; 